// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hrUa5KX14MpOcEgZxc6x {
  margin-right: 0.5rem;
}

.TcDgwf57BCResfBKwcxv {
  margin-left: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/LinkContent/LinkContent.module.css"],"names":[],"mappings":"AAAA;EACE,oBAAiB;AACnB;;AAEA;EACE,mBAAgB;AAClB","sourcesContent":[".left {\n  margin-right: 8px;\n}\n\n.right {\n  margin-left: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"left": `hrUa5KX14MpOcEgZxc6x`,
	"right": `TcDgwf57BCResfBKwcxv`
};
export default ___CSS_LOADER_EXPORT___;
